/**
 * 通用rem转换工具函数
 * 可在任何JavaScript文件中使用
 */

const BASE_FONT_SIZE = 16; // 基准字体大小

/**
 * 将px转换为rem
 * @param {number} px - 像素值
 * @returns {string} rem值
 */
export function pxToRem(px) {
  return (px / BASE_FONT_SIZE) + 'rem';
}

/**
 * 将rem转换为px
 * @param {number|string} rem - rem值
 * @returns {number} 像素值
 */
export function remToPx(rem) {
  const remValue = typeof rem === 'string' ? parseFloat(rem) : rem;
  return remValue * BASE_FONT_SIZE;
}

/**
 * 批量转换px到rem
 * @param {Object} styles - 样式对象
 * @returns {Object} 转换后的样式对象
 */
export function convertStyles(styles) {
  const converted = {};
  for (const [key, value] of Object.entries(styles)) {
    if (typeof value === 'number' && key !== 'opacity' && key !== 'zIndex' && key !== 'lineHeight') {
      converted[key] = pxToRem(value);
    } else {
      converted[key] = value;
    }
  }
  return converted;
}

// 默认导出最常用的函数
export default pxToRem;